import React, { useCallback, useEffect, useState } from "react";
import { GetQueryString, isPad } from "../../Utils";
import { fetchResetPassword, fetchVerifyToken } from "../../Utils/api";
import { VerifyPassword } from "../VerifyPage";


import '../VerifyPage/index.css'

import './index.css';

const bandgeImg = require('../../assets/icon_bandge.png');
const eyeImg = require('../../assets/icon_eye.png');
const slashEyeImg = require('../../assets/icon_eye_slash.png');
const checkGreeImg = require('../../assets/icon_check_green.png');



const _sub = (value) => {
  if (_passwordLen(value) && _passwordUp(value) && _passwordNum(value)) {
    return true;
  }
  return false;
}

// ^ (?=.* [A - Z])(?=.*\d)[a - zA - Z\d!@#$%^&*]{ 8,} $
// length >= 8
const _passwordLen = (value) => {
  const exp = RegExp(/[a-zA-Z\d]{8,}/);
  return value && exp.test(value);
}

// 包含大寫字母
const _passwordUp = (value) => {
  const exp = RegExp(/^(?=.*[A-Z])/);
  return value && exp.test(value);
}

// 包含數字
const _passwordNum = (value) => {
  const exp = RegExp(/(?=.*\d)/);
  return value && exp.test(value);
}

export const ResetPage = ({ trans }) => {
  const [instance] = useState({});
  const [inpType, setInpType] = useState(true);
  const [password, setPassword] = useState('');
  const [resetRes, setResetRes] = useState(false);
  const [verifyMes, setVerifyMes] = useState('')

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    }
  }, [])

  const onKeyDown = ({ keyCode }) => {
    if (keyCode === 13 && _sub(instance.password)) {
      subPassword()
    }
  }

  const valueChange = useCallback((value) => {
    let val = value.replace(/\s*/g, "");
    val = val.replace(/[\u4e00-\u9fa5]/ig, '')
    setPassword(val || '');
    instance.password = val;
  }, [])

  const subPassword = useCallback(async () => {
    try {
      const key = GetQueryString('oobCode');
      const apikey = GetQueryString('apiKey');
      const { error = {} } = await fetchResetPassword(key, instance.password, apikey);

      const { code, message } = error || {};
      setResetRes(true);

      if (code) {
        // error-type
        instance.verifyRes = false;
        setVerifyMes(trans[message] || trans.link_has_exp);
      } else {
        // success-type
        instance.verifyRes = true;
        setVerifyMes(trans.reset_successed)
      }
    } catch (error) {
      instance.verifyRes = false;
      setVerifyMes(trans.network_err)
      console.log('***_subPassword_***', error)
    }
  }, [instance])

  return <div>
    {
      resetRes ?
        <VerifyPassword trans={trans} verifyMes={verifyMes} verifyRes={instance.verifyRes}/> :
        <ResetCont
          trans={trans}
          inpType={inpType}
          password={password}
          setInpType={setInpType}
          subPassword={subPassword}
          valueChange={valueChange}
        />
    }
  </div>
}

const ResetCont = ({ trans, inpType, password, setInpType, subPassword, valueChange }) => {
  return <div className="main_body" style={{ marginTop: isPad() ? '22vh' : '13vh' }}>
    <img src={bandgeImg} className="bandge_img" alt="bandge" />
    <div className="text_light">{trans.reset_password}</div>
    <div className="text_gray reset_desc">{trans.verified_and_reset}</div>
    <div className="inp_cont">
      {
        password && <div className="text_gray pas_top_title">{trans.password}</div>
      }
      <input
        className="inp_sel"
        placeholder={trans.set_your_password}
        type={inpType ? 'password' : 'text'}
        value={password}
        onChange={e => valueChange(e.target.value)}
      />
      <img className="eye_img" src={inpType ? eyeImg : slashEyeImg} alt="eye" onClick={() => {
        setInpType(!inpType)
      }} />
    </div>
    <div className="pass_rule mt5">
      {_passwordLen(password) && <img className="green_check" src={checkGreeImg} alt="check" />}
      <div className="rule_gray" style={{ color: _passwordLen(password) ? '#34C759' : '#808093' }}>{trans.min_8_character}</div>
    </div>
    <div className="pass_rule">
      {_passwordUp(password) && <img className="green_check" src={checkGreeImg} alt="check" />}
      <div className="rule_gray" style={{ color: _passwordUp(password) ? '#34C759' : '#808093' }}>{trans.at_least_1_captial}</div>
    </div>
    <div className="pass_rule">
      {_passwordNum(password) && <img className="green_check" src={checkGreeImg} alt="check" />}
      <div className="rule_gray" style={{ color: _passwordNum(password) ? '#34C759' : '#808093' }}>{trans.at_least_1_num}</div>
    </div>
    <div className="sub_btn" style={{ background: _sub(password) ? '#FF3E00' : '#50505E' }} onClick={() => {
      if (_sub(password)) {
        subPassword()
      }
    }}>
      {trans.forget_password_btn}
    </div>
  </div>
}


